import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.66 6.447A.67.67 0 0 0 14.085 6l-3.793-.553L8.593 2a.667.667 0 0 0-1.2 0l-1.7 3.44L1.898 6a.67.67 0 0 0-.54.453.67.67 0 0 0 .167.667l2.753 2.667-.667 3.786a.667.667 0 0 0 .967.714l3.414-1.78 3.4 1.786c.093.053.199.08.306.08a.67.67 0 0 0 .624-.42.67.67 0 0 0 .036-.373l-.666-3.787 2.753-2.666a.67.67 0 0 0 .213-.68m-4.1 2.666a.67.67 0 0 0-.194.594l.48 2.793-2.507-1.333a.67.67 0 0 0-.626 0L5.206 12.5l.48-2.793a.67.67 0 0 0-.194-.594l-2-2L6.3 6.707a.67.67 0 0 0 .507-.367L7.992 3.8l1.254 2.547a.67.67 0 0 0 .506.366l2.807.407z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })